//auth Action Types
// Create
export const ACCOUNT_CREATION_STARTED = "ACCOUNT_CREATION_STARTED";
export const ACCOUNT_CREATION_SUCCES = "ACCOUNT_CREATION_SUCCES";
export const ACCOUNT_CREATION_FAIL = "ACCOUNT_CREATION_FAIL";

//account details
export const ACCOUNT_DETAILS_STARTED = "ACCOUNT_DETAILS_STARTED";
export const ACCOUNT_DETAILS_SUCCESS = "ACCOUNT_DETAILS_SUCCESS";
export const ACCOUNT_DETAILS_FAIL = "ACCOUNT_DETAILS_FAIL";

//Fetch
export const ACCOUNT_FETCH_STARTED = "ACCOUNT_FETCH_STARTED";
export const ACCOUNT_FETCH_SUCCES = "ACCOUNT_FETCH_SUCCES";
export const ACCOUNT_FETCH_FAIL = "ACCOUNT_FETCH_FAIL";

//Update
export const ACCOUNT_UPDATE_STARTED = "ACCOUNT_UPDATE_STARTED";
export const ACCOUNT_UPDATE_SUCCES = "ACCOUNT_UPDATE_SUCCES";
export const ACCOUNT_UPDATE_FAIL = "ACCOUNT_UPDATE_FAIL";

//Delete
export const ACCOUNT_DELETE_STARTED = "ACCOUNT_DELETE_STARTED";
export const ACCOUNT_DELETE_SUCCES = "ACCOUNT_DELETE_SUCCES";
export const ACCOUNT_DELETE_FAIL = "ACCOUNT_DELETE_FAIL";
